import RestRepository from '@candybox/repository/rest.js';
import ProductAnalytics from '@app/analytics/documents/product-analytics.js';
import ProductAnalyticsMap from '@app/analytics/requests/product-analytics-repository.js';
import { singleton } from "@candybox/helpers.js";


export default singleton(() => {
    return new RestRepository(ProductAnalytics, ProductAnalyticsMap());
})
